import { apiFetch } from "./supabase";

const SETTINGS_ID = 1;

const DEFAULT_SETTINGS = {
  registration_open_date: "2026-01-01",
  season_start: "2026-05-10",
  season_end: "2026-09-07",
  evening_times_change_date: "2026-08-14",
  first_rota_freeze_date: "2026-04-17",
  second_rota_freeze_date: "2026-07-01",
  enable_duty_swaps: true,
  registration_year: "2026",
  price_cutoff_date: "2026-04-04",
  individual_price_early: "40",
  individual_price_late: "55",
  family_price_early: "55",
  family_price_late: "70",
  first_officer_training_day: "1 March 26 (9am-5pm)",
  first_officer_pool_sessions: "8 March 26 (10am-12pm), 15 March 26 (10am-12pm)",
  first_officer_deadline: "2026-03-14",
  first_officer_discount: "50",
  second_officer_theory_sessions: "4 March 26 (7:30-9:30pm), 11 March 26 (7:30-9:30pm)",
  second_officer_pool_sessions: "6 April 26 (11:15-12:15am), 13 April 26 (11:15-12:15am)",
  second_officer_deadline: "2026-04-24",
  evening_start: "18:30",
  evening_end: "20:30",
  evening_late_season_end: "19:45",
  weekend_start: "15:00",
  weekend_end: "17:00",
  school_holiday_start: "14:30",
  school_holiday_end: "16:30",
  season_closed: false,
  season_closed_message: "",
  chatbot_monthly_token_limit: 100000,
  rota_pool_days: JSON.stringify([2, 3, 5, 6, 0]),
  rota_school_holidays: JSON.stringify([])
};

export async function loadSettings() {
  try {
    const { settings } = await apiFetch("/api/settings");
    if (!settings) return DEFAULT_SETTINGS;
    return { ...DEFAULT_SETTINGS, ...settings };
  } catch (err) {
    console.error("Error loading settings:", err);
    return DEFAULT_SETTINGS;
  }
}

export async function saveSettings(settings) {
  try {
    const { rota_pool_days, rota_school_holidays, ...dbSettings } = settings;
    await apiFetch("/api/admin/settings", { method: "PUT", body: dbSettings });
    return { success: true };
  } catch (err) {
    console.error("Error saving settings:", err);
    return { success: false, error: err.message };
  }
}

export function parseTrainingDates(dateString) {
  if (!dateString) return [];
  return dateString.split(",").map(d => d.trim()).filter(d => d);
}

export function parseSessionsWithTimes(sessionString) {
  if (!sessionString) return [];
  return sessionString.split(",").map(s => {
    const match = s.trim().match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      return { DATE: match[1].trim(), TIME: match[2].trim() };
    }
    return { DATE: s.trim(), TIME: "" };
  }).filter(s => s.DATE);
}

export function parseDateFromString(dateStr) {
  if (!dateStr) return null;
  // Remove time in parentheses if present
  const cleanDate = dateStr.replace(/\s*\([^)]*\)/, '').trim();
  // Parse "1 March 26" format
  const match = cleanDate.match(/^(\d{1,2})\s+(\w+)\s+(\d{2})$/);
  if (match) {
    const [, day, month, year] = match;
    const fullYear = 2000 + parseInt(year);
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                        'July', 'August', 'September', 'October', 'November', 'December'];
    const monthIndex = monthNames.findIndex(m => m.toLowerCase().startsWith(month.toLowerCase()));
    if (monthIndex !== -1) {
      // Set to end of day so sessions on current day are still available
      return new Date(fullYear, monthIndex, parseInt(day), 23, 59, 59);
    }
  }
  return null;
}

export { DEFAULT_SETTINGS };
